<template>
  <div class="dusk_toast_root">
    <transition
      name="fade"
      appear
      @after-enter="afterEnter"
      @after-leave="afterLeave"
    >
      <div
        v-if="enableToast"
        class="toast"
        :class="toastClass"
      >
        <div class="toast_icon_wrap">
          <span
            class="icon toast_check"
            :class="toastIcon"
          />
        </div>
        <span class="toast_text">{{ toastText }}</span>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  data() {
    return {
      enableToast: false,
      isAnimation: false,
      toastClass: '',
      toastIcon: '',
      toastText: '',
      queue: [],
    };
  },
  created() {
    this.$eventBus.on('open-toast', this.requestToast);
  },
  methods: {
    afterEnter() {
      setTimeout(this.startLeave, 1000);
    },
    afterLeave() {
      this.isAnimation = false;
      this.checkRequest();
    },
    checkRequest() {
      if (this.isAnimation) {
        return;
      }
      if (this.queue.length > 0) {
        const item = this.queue.shift();
        this.openToast(item.toastKind, item.toastText);
      }
    },
    openToast(kind, text) {
      switch (kind) {
        case 'success':
          this.toastClass = 'toast_success';
          this.toastIcon = 'icon_check';
          break;
        case 'error':
          this.toastClass = 'toast_error';
          this.toastIcon = 'icon_cross';
          break;
        default:
          break;
      }
      this.toastText = text;
      this.enableToast = true;
      this.isAnimation = true;
    },
    requestToast(kind, text) {
      this.queue.push({ toastKind: kind, toastText: text });
      this.checkRequest();
    },
    startLeave() {
      this.enableToast = false;
    },
  },
};
</script>

<style scoped>
.fade-enter-active {
  transition: opacity 0.2s;
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
